import React  from 'react';

const Enclosure63 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3>一、维修业务主管岗位职责</h3>
            <p>1、负责前台维修业务主管协调安排统筹的具体工作。</p>
            <p>2、不断学习行业相关知识，让企业及各部门工作标准化和规范化。</p>
            <p>3、制定、安排和协调工作的具体展开，维修车间、收银员、三包索赔、配件之间的具体工作。</p>
            <p>4、落实监督维修车间、维修质检、配件管理、维修结算员等各岗位的考核工作。</p>
            <p>5、贯彻与执行各厂家及行业的服务流程，并不断改进提出合理的改进措施。</p>
            <p>6、负责外出救援、客户接待、取送车业务的综合调度和人员安排。</p>
            <p>7、负责提升客户满意度，不断优化服务工作流程，保证服务时效及服务质量，相关数据透明化。</p>
            <p>8、监督服务负责解决服务过程中客户发生的纠纷，处理重大客户投诉，并不断优化客诉投诉处理流程，服务质量，并随时予以提醒和纠正，强化劳动纪律。</p>
            <p>9、做好业务统计分析工作、定期、按时完成各项数据各种报表汇报。</p>
            <p>10、客户资源管理、建立客户动态台账，方便开展各项服务活动，扩大业务范围。</p>
            <br/>
            <h3>二、技术主管岗位职责</h3>
            <p>1、负责车间维修的现场指导，协助处理技术难题。</p>
            <p>2、负责客户、厂家的技术难题攻关，行业市场新技术的研究。</p>
            <p>3、负责监督、指导维修人员使用专用工具及设备。</p>
            <p>4、负责技术资料搜集整理，并定期开展理论和实践培训。</p>
            <p>5、负责收集和分析重大技术，疑难案例及质量信息汇总，分析故障原因存档。</p>
            <p>6、负责整个维修车间的售后技术能力提升。</p>
            <p>7、定期学习行业相关的法律、法规、规章及制度。</p>
            <br/>
            <h3>三、三包索赔员岗位职责</h3>
            <p>1、对索赔科科长负责，坚决服从并执行其工作指令； </p>
            <p>2、负责代理品牌的三包索赔管理工作，三包服务的单据提报、客户维护、厂家对接;     </p>
            <p>3、负责配合客户服务科完成客户接待，电话接听服务派工、客户信息收集、按照车间作业流程及标准执行</p>
            <p>4、负责所有品牌提报的服务单有效性和准确率;   </p>
            <p>5、负责所有品牌单据提报，保证各品牌厂家工时费系数最高;</p>
            <p>6、负责对当日服务派工及到站车辆进行服务跟踪，提高有效政策性索赔单据生成，利润最大化； </p>
            <p>7、负责按照各厂家规定对日常产生的三包索赔旧件收集返厂、费用跟踪结算；</p>
            <p>8、负责对本部门人员进行各品牌厂家的服务政策培训和政策执行落地； </p>
            <p>9、负责保质保量的完成主管领导安排的临时工作。   </p>
            <br/>
            <h3>四、汽车维修质检员岗位职责</h3>
            <p>1、认真学习汽车维修质量检验有关法律、法规、规章;</p>
            <p>2、熟悉机修、电工、钣金、喷漆工种的基本操作过程，掌握其技术要求、标准。严格执行国家及行业的有关汽车维修技术标准和其它相关技术标准;</p>
            <p>3、负责进厂维修车辆的检验、检测、诊断工作;</p>
            <p>4、负责维修车辆在维修过程中的各项检验工作，包括过程和竣工检验，严把维修质量关，并按规定的要求认真填写维修质量检验签证单和车辆技术档案;</p>
            <p>5、负责维修车辆检测工作，及时进行质量分析，为不断改进质量提出意见和建议;</p>
            <p>6、做好汽车维修质量状况的上传下达工作，当好领导的参谋，起到顾客和维修工、领导和职员工间的桥梁作用;</p>
            <p>7、参与汽车返修或机务事故原因分析和质量判断;</p>
            <p>8、秉公行使质量检验和技术鉴定的职权;</p>
            <p>9、负责协调接待前台与维修车间的车辆维修工序、工期、换件、待料等信息接转。</p>
            <br/><br/>
        </div>
    </div>


export default Enclosure63;